/* lua.js generated code 0.3.0 */

NumLabelMultiBg = xClass("NumLabelMultiBg", function (layer) {
    return layer
})
NumLabelMultiBg.prototype.ctor = function () {
    var self = this
    self.init()
}
NumLabelMultiBg.prototype.init = function () {
    var self = this
    self.text = self.getChildByName("text")
    self.textBounding = clone(self.text.getContentSize())
    self.bg = table()
    var $st3 = self.getChildren()
    for (var i = 1, v = $st3[1]; v; i++, v = $st3[i]) {
        if (string.starts(v.getName(), "bg_")) {
            self.bg[string.sub(v.getName(), 4)] = v
        }
    }
}
NumLabelMultiBg.prototype.setNum = function (value) {
    var self = this
    if (type(value) === "number" && value > 99) {
        self.text.setString("99+")
    } else {
        self.text.setString(tostring(value))
    }
    var size = self.text.getContentSize()

    // self.textBounding.width 在初始化的时候 width 是 0，这里默认给24
    var scale = Math.min((self.textBounding.width || 24) / size.width, self.textBounding.height / size.height)
    if (scale > 1) {
        scale = 1
    }
    self.text.setScale(scale)
}
// cc.c4b
NumLabelMultiBg.prototype.setTextColor = function (color) {
    var self = this
    self.text.setTextColor(color)
}
NumLabelMultiBg.prototype.setBackground = function (name) {
    var self = this
    for (var k in self.bg) {
        var v = self.bg[k]
        v.setVisible(k === name)
    }
}
